document.addEventListener('alpine:init', function () {
    Alpine.data('styleFilters', function () {
        return {
            init: function () {
                var _this = this;
                return function () {
                    _this.scrollIntoView();
                };
            },
            scrollIntoView: function () {
                this.$refs.selected && this.$refs.selected.scrollIntoView();
            },
        };
    });
});
